export enum VariableOptionType {
  HINGE_SET = "HINGE_SET",
  LOCK_SET = "LOCK_SET",
  ROLLER_BOARD = "ROLLER_BOARD",
  FEET = "FEET",
  DISHES = "DISHES",
  HANDLES = "HANDLES",
  TROLLEY_HANDLES = "TROLLEY_HANDLES",
  RUNNERS = "RUNNERS",
  CUTOUTS = "CUTOUTS",
}
